function resizeMenuDrawer(){
  if(document.querySelector('body').classList.contains('open-menu')){
    document.querySelector('.snippet-menu-drawer').style.height = document.querySelector('.mob-menuwrap').clientHeight+'px';
  }else{
    document.querySelector('.snippet-menu-drawer').style.height = '';
  }
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelectorAll('#predictive-search');
    
    this.input.addEventListener('click', this.debounce((event) => {
      document.querySelector('body').classList.add('open-mobile-search');
      resizeMenuDrawer();
    }).bind(this));
    
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if (input_length > 0) {
        document.querySelectorAll('.search-Button').forEach(function(searchButton) {
          searchButton.disabled = false;
        });
      } else {
        document.querySelectorAll('.search-Button').forEach(function(searchButton) {
          searchButton.disabled = true;
        });
      } 
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.forEach(function(predictiveResult) {
        predictiveResult.innerHTML = resultsMarkup;
      });
      this.open();
      if (document.querySelector('.search_recommended_wrap')) {
        if (document.querySelector('.top-result').getAttribute('data-count') == '0') {
          document.querySelectorAll('.snippet-search-bar').forEach(function(predictiveResult) {
            predictiveResult.classList.add('no-search-results');
          });
          resizeMenuDrawer();
        } else {
          document.querySelectorAll('.snippet-search-bar').forEach(function(predictiveResult) {
            predictiveResult.classList.remove('no-search-results');
          });
          resizeMenuDrawer();
        }
      }
      if (typeof quickAddButton == 'function') {
        quickAddButton();
      }
      if(document.querySelectorAll('#SearchValue')) document.querySelectorAll('#SearchValue').forEach(function(searchVal) {
        searchVal.value = searchTerm;
      });
      // if (document.getElementById('SearchValue')) {
      //   document.getElementById('SearchValue').value = searchTerm;
      // }
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }

  open() {
    document.querySelectorAll('.snippet-search-bar').forEach(function(predictiveResult) {
      predictiveResult.classList.add('active-search-results');
    });
    resizeMenuDrawer();
  }

  close() {
    document.querySelectorAll('.snippet-search-bar').forEach(function(predictiveResult) {
      predictiveResult.classList.remove('active-search-results');
    });
    resizeMenuDrawer();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
if(window.location.pathname === '/collections' || window.location.pathname === '/collections/' || window.location.pathname === '/en/collections/' || window.location.pathname === '/en/collections' || window.location.pathname === '/de/collections/' || window.location.pathname === '/de/collections'){
  window.location.replace('/collections/alle-items-heren');
}

document.addEventListener('click', function(e) { 
const sizeList = e.target.closest('.variant-grid');
if (sizeList.dataset.quickAddBound === 'true') return;
      sizeList.dataset.quickAddBound = 'true';
  if (sizeList) {
    e.preventDefault();
    let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');

        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422){
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
  }

});
// if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    console.log("Calling quickAddButton() from theme.js");
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      if (sizeList.dataset.quickAddBound === 'true') return;
      sizeList.dataset.quickAddBound = 'true';

      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');

        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422){
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  }
  // quickAddButton();
// }

document.addEventListener('mouseover', function(e) {
  const btn = e.target.closest('.quickshop');
  if (!btn) return;

  const card = btn.closest('.snippet-product-grid');
  if (card) card.classList.add('view-sizes');
});

// Open sizes on click (mobile / fallback)
document.addEventListener('click', function(e) {
  const quickshopBtn = e.target.closest('.quickshop');
  if (quickshopBtn) {
    e.preventDefault();
    const card = quickshopBtn.closest('.snippet-product-grid');
    if (card) card.classList.add('view-sizes');
    return;
  }

  const closeBtn = e.target.closest('.variant-close');
  if (closeBtn) {
    e.preventDefault();
    e.stopPropagation();
    const card = closeBtn.closest('.snippet-product-grid');
    if (card) card.classList.remove('view-sizes');
  }
});

// Close on leaving image box (desktop) via mouseout delegation
document.addEventListener('mouseout', function(e) {
  const box = e.target.closest('.grid-imagebox');
  if (!box) return;

  // Ignore internal moves within the same card
  if (box.contains(e.relatedTarget)) return;

  const card = box.closest('.snippet-product-grid');
  if (card) card.classList.remove('view-sizes');
});

if(document.querySelectorAll('.nav-arrow')) document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
  navArrow.addEventListener('click',function(e){
    navArrow.closest('li').classList.toggle('active');
  });
});
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    if(document.querySelector('.snippet-menu-drawer')) document.querySelector('.snippet-menu-drawer').style.height = '';
    document.querySelector('body').classList.remove('active-popup','open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};
// class LocalizationForm extends HTMLElement {
//   constructor() {
//     super();
//     this.elements = {
//       input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
//       button: this.querySelector('button'),
//       panel: this.querySelector('ul'),
//     };
//     this.elements.button.addEventListener('click', this.openSelector.bind(this));
//     this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
//     this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
//     this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
//   }
//   hidePanel() {
//     this.elements.button.setAttribute('aria-expanded', 'false');
//     this.elements.panel.setAttribute('hidden', true);
//   }
//   onContainerKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;
//     this.hidePanel();
//     this.elements.button.focus();
//   }
//   onItemClick(event) {
//     event.preventDefault();
//     const form = this.querySelector('form');
//     this.elements.input.value = event.currentTarget.dataset.value;
//     if (form) form.submit();
//   }
//   openSelector() {
//     this.elements.button.focus();
//     this.elements.panel.toggleAttribute('hidden');
//     this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
//   }
//   closeSelector(event) {
//     const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
//     if (event.relatedTarget === null || shouldClose) {
//       this.hidePanel();
//     }
//   }
// }
// customElements.define('localization-form', LocalizationForm);
// let langBtn = document.querySelector('.language_switcher span');
// if(langBtn) langBtn.addEventListener('click',function(e){
//   e.preventDefault();
//   langBtn.closest('.language_switcher').querySelector('.disclosure__list').classList.add('active');
// });
// if(document.querySelectorAll('.language_switcher .disclosure__list')) document.querySelectorAll('.language_switcher .disclosure__list').forEach((closeLang) => {
//   if(closeLang) closeLang.addEventListener('click',function(e){
//     e.preventDefault();
//     setTimeout(() => {
//       closeLang.closest('.disclosure__list').classList.remove('active');
//     }, 1000);
//   });
// });
// if(document.querySelectorAll('.language_switcher .weglot_switcher>div')) document.querySelectorAll('.language_switcher .weglot_switcher>div').forEach((closeLang) => {
//   if(closeLang) closeLang.addEventListener('click',function(e){
//     e.preventDefault();
//     setTimeout(() => {
//       closeLang.closest('.disclosure__list').classList.remove('active');
//     }, 1000);
//   });
// });
if(document.querySelectorAll('.metafield-colors li')) document.querySelectorAll('.metafield-colors li').forEach((color) => {
  color.addEventListener('mouseover',function(){
    if(color.querySelector('img') != null || color.getAttribute('data-price') || color.getAttribute('data-compare-price') && color.closest('.snippet-product-grid') != null){
      color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.querySelector('img').getAttribute('src'));
      color.closest('.snippet-product-grid').querySelector('.grid-meta .regular-price').textContent = color.getAttribute('data-price');
      color.closest('.snippet-product-grid').querySelector('.grid-meta .compare-price').textContent = color.getAttribute('data-compare-price');
    }
  })
  color.addEventListener('mouseout',function(){
    if(color.closest('.metafield-colors').querySelector('li.active').querySelector('img') != null || color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-price') ||  color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-compare-price') && color.closest('.snippet-product-grid') != null){
      color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.closest('.metafield-colors').querySelector('li.active img').getAttribute('src'));
      color.closest('.snippet-product-grid').querySelector('.grid-meta-price .regular-price').textContent = color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-price');
      color.closest('.snippet-product-grid').querySelector('.grid-meta-price .compare-price').textContent = color.closest('.metafield-colors').querySelector('li.active').getAttribute('data-compare-price');
    }
  })
})
if(document.querySelectorAll('.lbo-dots-wrap')) document.querySelectorAll('.lbo-dots-wrap').forEach(function(dotWrapper){
  dotWrapper.querySelectorAll('.lbo-dot').forEach(function(dot){
    dot.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let thisHandle = dot.getAttribute('data-handle');
      dotWrapper.querySelectorAll('.dot-prod').forEach(function(product){
        let prodHandle = product.getAttribute('data-handle');
        if(prodHandle == thisHandle){
          let dotWrap = product.closest('.lbo-dots-wrap');
          if(dotWrap.classList.contains('active-dot')){
            dotWrap.classList.remove('active-dot');
          }else{
            document.querySelectorAll('.lbo-dots-wrap').forEach(function(productRemove){
              productRemove.classList.remove('active-dot');
            });
            dotWrap.classList.add('active-dot');
          }
        }
      });
    });
  });
});
var counttime = 0;
function cartNotification(cartId){
  fetch(window.Shopify.routes.root +'?section_id=cart-notification')
  .then((response) => response.text())
  .then((responseText) => {
    const cnID = 'cart-notification';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart_popup');
    const source = html.getElementById(cnID);
    if(source && destination) destination.innerHTML = source.innerHTML;
    document.querySelector('body').classList.remove('stickybar');
    counttime = 0;
    const myInterval = setInterval(timer, 1000);
    function timer() {
      counttime++;
      if(counttime > 5){
        document.querySelector('.cart_popup').innerHTML = '';
        document.querySelector('body').classList.add('stickybar');
        myStop();
      }
    }
    function myStop(){
      clearInterval(myInterval);
    } 
    document.body.addEventListener('click',function(e){
      var popup = document.querySelector('.cart_popup');
      if (!popup.contains(event.target)) {
        popup.innerHTML = '';
      }
    })
  });
}
var SmartWishlistItemAdded = function(){
  var notification = document.getElementById('sw_added_notification');
  // notification.style.display = 'flex';
  notification.classList.add('active');
  setTimeout(function(){
    // notification.style.display = 'none';
    notification.classList.remove('active');
  }, 5000);
  notification.querySelector('.sw_alert_close').addEventListener('click',function(e){
    e.preventDefault();
    // notification.style.display = 'none';
    notification.classList.remove('active');
  })
  // Lightly normalize wishlist badge after app updates it
  setTimeout(function(){ if (typeof capWishlistBadge === 'function') capWishlistBadge(); }, 50);
};
var SmartWishlistItemRemoved = function(){
  var notification = document.getElementById('sw_removed_notification');
  // notification.style.display = 'flex';
  notification.classList.add('active');
  setTimeout(function(){
    // notification.style.display = 'none';
    notification.classList.remove('active');
  }, 5000);
  notification.querySelector('.sw_alert_close').addEventListener('click',function(e){
    e.preventDefault();
    // notification.style.display = 'none';
    notification.classList.remove('active');
  })
  // Lightly normalize wishlist badge after app updates it
  setTimeout(function(){ if (typeof capWishlistBadge === 'function') capWishlistBadge(); }, 50);
};
SWCallbackExpressWishlistProductItemAdded = 
SWCallbackExpressWishlistCollectionItemAdded = 
SWCallbackCustomerWishlistProductItemAdded = 
SWCallbackCustomerWishlistCollectionItemAdded = SmartWishlistItemAdded;

SWCallbackExpressWishlistProductItemRemoved = 
SWCallbackExpressWishlistCollectionItemRemoved = 
SWCallbackCustomerWishlistProductItemRemoved = 
SWCallbackCustomerWishlistCollectionItemRemoved = SmartWishlistItemRemoved;
document.body.insertAdjacentHTML('beforeend', 
  `<div id="sw_added_notification">
    <a href="/a/wishlist" class="sw_alert sw_alert_added">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16" fill="none"><path d="M0.582117 15.4412L5.5 12.3854L10.4179 15.4412C10.4781 15.4787 10.5584 15.4974 10.6186 15.4974C10.6788 15.4974 10.7391 15.4787 10.7993 15.4599C10.9197 15.4037 11 15.2724 11 15.1412V1.90601C11 1.11864 10.3175 0.5 9.49453 0.5H1.50547C0.662409 0.5 0 1.13739 0 1.90601V15.1412C0 15.2724 0.080292 15.3849 0.20073 15.4599C0.321168 15.5162 0.461679 15.5162 0.582117 15.4412Z" fill="white"></path></svg>
      <span>Item added</span>
    </a>
    <a href="#" class="sw_alert_close"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M13.6286 0.5L7.5 6.62856L1.37143 0.5L1 0.871437L7.12858 7L1 13.1286L1.37143 13.5L7.50001 7.37142L13.6286 13.5L14 13.1286L7.87143 7L14 0.871437L13.6286 0.5Z" fill="white" stroke="white" stroke-width="0.5"></path></svg></a>
  </div>` +
  `<div id="sw_removed_notification">
    <div class="sw_alert sw_alert_removed">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 10 13" fill="none"><path d="M0.529197 12.949L5 10.3007L9.4708 12.949C9.52555 12.9815 9.59854 12.9978 9.65328 12.9978C9.70803 12.9978 9.76277 12.9815 9.81752 12.9653C9.92701 12.9165 10 12.8028 10 12.6891V1.21854C10 0.536157 9.37956 0 8.63139 0H1.36861C0.60219 0 0 0.552405 0 1.21854V12.6891C0 12.8028 0.0729927 12.9003 0.182482 12.9653C0.291971 13.014 0.419708 13.014 0.529197 12.949ZM0.69343 1.21854C0.69343 0.877348 1.00365 0.601146 1.38686 0.601146H8.63139C9.0146 0.601146 9.32482 0.877348 9.32482 1.21854V12.1204L5.18248 9.68332C5.12774 9.65083 5.05474 9.63458 5 9.63458C4.94525 9.63458 4.87226 9.65083 4.81752 9.68332L0.69343 12.1204V1.21854Z" fill="currentColor" style=""></path></svg>
      <span>Item removed</span>
    </div>
    <a href="#" class="sw_alert_close"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M13.6286 0.5L7.5 6.62856L1.37143 0.5L1 0.871437L7.12858 7L1 13.1286L1.37143 13.5L7.50001 7.37142L13.6286 13.5L14 13.1286L7.87143 7L14 0.871437L13.6286 0.5Z" fill="white" stroke="white" stroke-width="0.5"></path></svg></a>
  </div>`
);

// No-flicker wishlist badge capping: render via data attribute instead of editing text
function capWishlistBadgeFor(badge){
  try {
    if (!badge) return;
    var raw = (badge.textContent || '').trim();
    var num = parseInt(raw, 10);
    if (isNaN(num)) return;
    if (num > 10) {
      if (badge.getAttribute('data-badge') !== '10+') badge.setAttribute('data-badge', '10+');
      badge.classList && badge.classList.add('long');
    } else if (num === 10) {
      if (badge.hasAttribute('data-badge')) badge.removeAttribute('data-badge');
      badge.classList && badge.classList.add('long');
    } else {
      if (badge.hasAttribute('data-badge')) badge.removeAttribute('data-badge');
      badge.classList && badge.classList.remove('long');
    }
  } catch(e) {}
}

function capWishlistBadge(){
  try {
    var badges = document.querySelectorAll('a[aria-label="Wishlist"] .topbadge, .mb-drawer-inr li.wishlist a[aria-label="Wishlist"] .topbadge');
    if (!badges || !badges.length) return;
    badges.forEach(function(b){ capWishlistBadgeFor(b); });
  } catch(e) {}
}

function initWishlistBadgeCapping(){
  var observed = new WeakSet();
  var attach = function(b){
    if (!b || observed.has(b)) return;
    observed.add(b);
    capWishlistBadgeFor(b);
    // Observe only text changes to avoid loops (we only write attributes)
    var obs = new MutationObserver(function(){ capWishlistBadgeFor(b); });
    obs.observe(b, { childList: true, characterData: true, subtree: true });
  };

  // Attach to any existing badges (desktop and mobile)
  var initialBadges = document.querySelectorAll('a[aria-label="Wishlist"] .topbadge, .mb-drawer-inr li.wishlist a[aria-label="Wishlist"] .topbadge');
  initialBadges.forEach(attach);

  // Watch for badges that might be injected later (e.g., mobile drawer)
  var wait = new MutationObserver(function(muts){
    muts.forEach(function(mut){
      mut.addedNodes && mut.addedNodes.forEach(function(node){
        if (!(node instanceof Element)) return;
        if (node.matches && (node.matches('a[aria-label="Wishlist"] .topbadge') || node.matches('.mb-drawer-inr li.wishlist a[aria-label="Wishlist"] .topbadge'))) {
          attach(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('a[aria-label="Wishlist"] .topbadge, .mb-drawer-inr li.wishlist a[aria-label="Wishlist"] .topbadge').forEach(attach);
        }
      });
    });
  });
  wait.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', function(){
  initWishlistBadgeCapping();
});


document.addEventListener("DOMContentLoaded", function() {
    const okendoStar = document.querySelector("[data-oke-star-rating]");
    const reviewContainer = document.querySelector("[data-title='review'] .body-badge.accordian-title");

    if (okendoStar && reviewContainer) {
        okendoStar.addEventListener("click", () => {
            reviewContainer.click();
        });
    }
});